// extracted by mini-css-extract-plugin
export default {"download":"DescargarDocumentos_download__4FIlH"};